import { Navigate } from 'react-router-dom';
import { getDefaultPathForRole, getStoredUser } from '../utils/authUtils';

export default function RootRedirect() {
  const token = localStorage.getItem('accessToken');
  if (!token) return <Navigate to="/login" replace />;
  const user = getStoredUser();
  const path = getDefaultPathForRole(user);
  return <Navigate to={path} replace />;
}
